import { StatementMapping } from "../data-model/medicalNecessityReview";

export const STATEMENT_MAPPINGS: StatementMapping = {
  // Patient 1 - Tony Stark
  "76e4eceb-d95c-44e2-9e71-663e92fdb540": {
    recommendation: {
      type: "approved",
      text: "We recommend that this case will be approved.",
    },
    Q1: {
      supportive_facts: [
        "Cardiac CT and CT Angiography are appropriate imaging modalities for evaluating cardiac structures and blood vessels, providing detailed visualization that supports accurate diagnosis and treatment planning.",
      ],
    },
    Q2: {
      supportive_facts: [
        "CT Angiography is an appropriate imaging modality for evaluating potential aortic erosion following ASD occlusion device placement, as this is a serious complication that requires prompt diagnosis and management.",
      ],
    },
    Q3: {
      supportive_facts: [
        "Pulmonary vein mapping via CT Angiography is clinically appropriate for pre-procedural planning in patients undergoing atrial fibrillation ablation, as it provides essential anatomical information about pulmonary vein ostia and left atrial structure.",
      ],
    },
    Q4: {
      supportive_facts: [
        "CT Angiography for TAVR planning is a well-established and necessary imaging study to assess aortic valve anatomy, annular dimensions, and vascular access routes, which are critical for successful transcatheter aortic valve replacement procedures.",
      ],
    },
    Q5: {
      supportive_facts: [
        "Cardiac CT for evaluating non-coronary cardiac structures and morphology is appropriate when assessing congenital heart disease, cardiac masses, pericardial disease, or other structural abnormalities that require detailed anatomical visualization.",
      ],
    },
    Q6: {
      supportive_facts: [
        "High-resolution coronary CTA using ≥64-slice technology is an appropriate non-invasive imaging method for evaluating coronary artery disease, providing detailed assessment of coronary anatomy and stenosis.",
      ],
    },
  },

  // Patient 2 - Clark Kent
  "7d5b393e-83de-4380-b5e4-90c82acc4620": {
    recommendation: {
      type: "denial",
      text: "The case is headed for potential Denial for not following step therapy protocols",
    },
    Q1: {
      supportive_facts: [
        "The selected indication, adenocarcinoma, is a well-recognized diagnosis, and treatment protocols for this type of cancer are well-established in clinical practice.",
      ],
    },
    Q2: {
      contradictory_facts: [
        "If the treatment for metastatic disease is chosen without confirming the metastatic status, it could lead to an incorrect approach, contradicting the step therapy requirement to use first-line or less aggressive treatments initially.",
      ],
    },
    Q3: {
      supportive_facts: [
        "Confirming that the cancer is castrate-resistant (mCRPC) is crucial for selecting appropriate treatment options, as this requires specific hormone therapy and advanced treatments to manage the condition effectively.",
      ],
    },
    Q4: {
      contradictory_facts: [
        "If the BRCA 1/2 test result is negative or not performed, selecting a treatment based on a mutation that isn't present would contradict the necessity for accurate genetic testing in determining the most effective therapy.",
      ],
    },
    Q5: {
      supportive_facts: [
        "If the patient has experienced disease progression or developed contraindications or intolerance to Taxotere, it is crucial to consider alternative treatment options to avoid further harm or ineffective treatment.",
      ],
    },
    Q6: {
      contradictory_facts: [
        "If the albumin level is greater than or equal to 3.2 g/dL, selecting a treatment plan based on a low albumin level could be inappropriate, as the patient's nutritional and liver function may be adequate to support the chosen treatment approach.",
      ],
    },
  },

  // Patient 3 - Selina Kyle
  "ecc436f8-2050-4007-a3c2-e0beb3437217": {
    recommendation: {
      type: "approved",
      text: "We recommend that this case will be approved.",
    },
    Q1: {
      supportive_facts: [
        "The selected indication, adenocarcinoma, is a well-recognized diagnosis, and treatment protocols for this type of cancer are well-established in clinical practice.",
      ],
    },
    Q2: {
      supportive_facts: [
        "The treatment selection for metastatic or recurrent cancer is appropriate, as it aligns with guidelines that prioritize aggressive therapy for advanced stages of the disease.",
      ],
    },
    Q3: {
      supportive_facts: [
        "Confirming that the cancer is castrate-resistant (mCRPC) is crucial for selecting appropriate treatment options, as this requires specific hormone therapy and advanced treatments to manage the condition effectively.",
      ],
    },
    Q4: {
      supportive_facts: [
        "A positive BRCA 1/2 mutation test indicates the presence of a genetic predisposition that could influence the choice of targeted therapies, supporting the use of treatments such as PARP inhibitors or other personalized options.",
      ],
    },
    Q5: {
      supportive_facts: [
        "If the patient has experienced disease progression or developed contraindications or intolerance to Taxotere, it is crucial to consider alternative treatment options to avoid further harm or ineffective treatment.",
      ],
    },
    Q6: {
      supportive_facts: [
        "The ECOG performance status of '1 - Restricted activity, minor symptoms' reflects a patient who is still able to perform most activities but with some limitations, making them eligible for treatment that requires a higher level of functional status.",
      ],
    },
    Q7: {
      supportive_facts: [
        "The ECOG performance status of '1 - Restricted activity, minor symptoms' reflects a patient who is still able to perform most activities but with some limitations, making them eligible for treatment that requires a higher level of functional status.",
      ],
    },
    Q8: {
      supportive_facts: [
        "If the albumin level is less than 3.2 g/dL, this indicates possible malnutrition or liver dysfunction, which may affect the patient's response to treatment. It is crucial to address this underlying issue to optimize treatment outcomes.",
      ],
    },
  },

  // Patient 4 - Natasha Romanoff
  "ea307d6f-22b9-4187-80f1-a15eb4f841c2": {
    Q1: {
      supportive_facts: [
        "The selected indication, adenocarcinoma, is a well-recognized diagnosis, and treatment protocols for this type of cancer are well-established in clinical practice.",
      ],
    },
    Q2: {
      contradictory_facts: [
        "If the treatment for metastatic disease is chosen without confirming the metastatic status, it could lead to an incorrect approach, contradicting the step therapy requirement to use first-line or less aggressive treatments initially.",
      ],
    },
    Q3: {
      contradictory_facts: [
        "If the patient's cancer is not confirmed to be castrate-resistant, this may lead to over-treatment with stronger therapies meant for mCRPC, which contradicts the need for more conservative treatment options based on the patient's actual condition.",
      ],
    },
    Q4: {
      supportive_facts: [
        "A positive BRCA 1/2 mutation test indicates the presence of a genetic predisposition that could influence the choice of targeted therapies, supporting the use of treatments such as PARP inhibitors or other personalized options.",
      ],
    },
    Q5: {
      supportive_facts: [
        "If the patient has experienced disease progression or developed contraindications or intolerance to Taxotere, it is crucial to consider alternative treatment options to avoid further harm or ineffective treatment.",
      ],
    },
    Q6: {
      supportive_facts: [
        "The ECOG performance status of '1 - Restricted activity, minor symptoms' reflects a patient who is still able to perform most activities but with some limitations, making them eligible for treatment that requires a higher level of functional status.",
      ],
    },
    Q7: {
      supportive_facts: [
        "The ECOG performance status of '1 - Restricted activity, minor symptoms' reflects a patient who is still able to perform most activities but with some limitations, making them eligible for treatment that requires a higher level of functional status.",
      ],
    },
    Q8: {
      supportive_facts: [
        "If the albumin level is less than 3.2 g/dL, this indicates possible malnutrition or liver dysfunction, which may affect the patient's response to treatment. It is crucial to address this underlying issue to optimize treatment outcomes.",
      ],
    },
  },
};
